import Vue from 'vue'
import Vuex from 'vuex'
import Axios from "axios"

import user from "./modules/user";
import staff from "./modules/staff";
import absen from "./modules/absen";
import wfh from "./modules/wfh";
import pengumuman from "./modules/pengumuman";
import device from "./modules/device";
import activitylog from "./modules/activitylog";
import roles from "./modules/roles";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || null,
    userRoles: {},
    activeRole: localStorage.getItem("activeRole") || null,
    info: {},
    code: null,
    message: null,
    status: null,
    loading: false,
    host: "https://api-intranet.lan.go.id",
  },
  getters: {
    isLoggedIn: state => !!state.token,
    currentRole: state => state.activeRole,
    hasRole: (state) => (role) => {
      if (Array.isArray(state.userRoles)) {
        return state.userRoles.includes(role)
      }
      return false
    },
    isAdmin: state => {
      return state.activeRole === 'ROLE_ADMIN' || 
             (Array.isArray(state.userRoles) && state.userRoles.includes('ROLE_ADMIN'))
    },
    isCurator: state => {
      return state.activeRole === 'ROLE_CURATOR' || 
             (Array.isArray(state.userRoles) && state.userRoles.includes('ROLE_CURATOR'))
    },
    canAccessAdminFeatures: state => {
      return state.activeRole === 'ROLE_ADMIN' || state.activeRole === 'ROLE_CURATOR'
    }
  },
  mutations: {
    set_token(state, token){
      state.token = token
    },
    set_role(state, roles) {
      state.userRoles = roles;
    },
    set_active_role(state, role) {
      state.activeRole = role;
      localStorage.setItem("activeRole", role);
    },
    set_info(state, info){
      state.info = info
    },
    set_code(state, code){
      state.code = code
    },
    set_message(state, message){
      state.message = message
    },
    set_status(state, status){
      state.status = status
    },
    set_loading(state, loading){
      state.loading = loading
    },
    set_logout(state) {
      state.token = null
      state.userRoles = {}
      state.activeRole = null
      state.info = {}
      state.code = null
      state.message = null
      state.status = null
      state.loading = false
    },
  },
  actions: {
    login({commit, state}, data) {
      return new Promise((resolve, reject) => {
        commit("set_loading", true);

        let data_login = {"username": data.username, "password": data.password};
        let url = state.host+"/auth/login";
        let headers = { 'Content-Type': 'application/json' };

        Axios.post(url, data_login, { headers: headers })
        .then(async (response) => {
          const token = response.data;

          localStorage.setItem("token", token.data.jwttoken);
          Axios.defaults.headers.common["Authorization"] = token.data.jwttoken;

          commit("set_loading", false);
          commit("set_token", token.data.jwttoken);
          
          // Automatically get roles after successful login
          try {
            await this.dispatch('get_roles');
          } catch (error) {
            console.warn("Failed to get roles after login:", error);
          }
          
          resolve(response);
        })
        .catch((error) => {
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          localStorage.removeItem("token");
          reject(error);
        })
      })
    },
    get_roles({ commit, state }) {
      return new Promise((resolve, reject) => {
        try {
          let ab = localStorage.getItem("token");
          if (!ab) {
            reject(new Error("No token found"));
            return;
          }
          
          let base64Url = ab.split(".")[1];
          let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
          let jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
              }).join("")
          );
          let cd = JSON.parse(jsonPayload);
          
          const authorities = cd.authorities || [];
          commit("set_role", authorities);
          commit("set_info", cd);
          
          // Auto-select role if user has only one role and no active role is set
          if (authorities.length === 1 && !state.activeRole) {
            commit("set_active_role", authorities[0]);
          }
          // If user already has an active role, verify it's still valid
          else if (state.activeRole && !authorities.includes(state.activeRole)) {
            // Clear invalid active role
            commit("set_active_role", null);
          }
          
          resolve(authorities);
        } catch (error) {
          console.error("Error parsing JWT token:", error);
          reject(error);
        }
      });
    },
    setActiveRole({ commit }, role) {
      commit("set_active_role", role);
    },
    logout: function({ commit }) {
      return new Promise((resolve) => {
        commit("set_logout");
        localStorage.removeItem("token");
        localStorage.removeItem("activeRole");
        delete Axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
  },
  modules: {
    user,
    staff,
    absen,
    wfh,
    pengumuman,
    device,
    activitylog,
    roles
  }
})
